import type { ReminderStrength } from './quick-reminders';

export const HOME_ROUTINE_REMINDER_STYLE_OPTIONS: Array<{
  value: ReminderStrength;
  label: string;
  description: string;
}> = [
  {
    value: 'once',
    label: 'Calm',
    description: 'One reminder when a Home job lands.',
  },
  {
    value: 'standard',
    label: 'Standard',
    description: 'A morning reminder, then an evening follow-up if it is still waiting.',
  },
  {
    value: 'pester',
    label: 'Pester',
    description: 'A morning reminder, a midday nudge, and an evening follow-up.',
  },
];

export function normalizeHomeRoutineReminderStrength(value: unknown): ReminderStrength {
  return value === 'once' || value === 'pester' || value === 'standard'
    ? value
    : 'standard';
}

function startOfLocalDay(value: Date) {
  return new Date(value.getFullYear(), value.getMonth(), value.getDate());
}

function buildLocalDate(value: Date, hours: number, minutes = 0) {
  return new Date(
    value.getFullYear(),
    value.getMonth(),
    value.getDate(),
    hours,
    minutes,
    0,
    0,
  );
}

function resolveAnchorDate(dueDate: string, now: Date) {
  const parsedDueDate = new Date(`${dueDate}T00:00:00`);
  if (Number.isNaN(parsedDueDate.getTime())) {
    return null;
  }

  const today = startOfLocalDay(now);
  return parsedDueDate.getTime() < today.getTime() ? today : parsedDueDate;
}

function getCandidateSlots(strength: ReminderStrength) {
  if (strength === 'pester') {
    return [
      { hours: 9, minutes: 0 },
      { hours: 13, minutes: 0 },
      { hours: 18, minutes: 0 },
    ];
  }

  return [
    { hours: 9, minutes: 0 },
    { hours: 18, minutes: 0 },
  ];
}

export function buildHomeRoutineNotificationDates(
  dueDate: string,
  strength: ReminderStrength,
  now = new Date(),
) {
  const anchorDate = resolveAnchorDate(dueDate, now);
  if (!anchorDate) {
    return [] as Date[];
  }

  const futureSlots = getCandidateSlots(strength)
    .map((slot) => buildLocalDate(anchorDate, slot.hours, slot.minutes))
    .filter((slot) => slot.getTime() > now.getTime());

  if (strength === 'once') {
    return futureSlots.slice(0, 1);
  }

  return futureSlots;
}

export function getHomeRoutineReminderStyleLabel(value: ReminderStrength) {
  return HOME_ROUTINE_REMINDER_STYLE_OPTIONS.find((option) => option.value === value)?.label || 'Standard';
}
